import $ from 'jquery';
import fitVids from 'fitvids';
import rimg from 'rimg-shopify';

function loadVimeoThumbnail(vimeoId) {
  $.getJSON(`http://vimeo.com/api/v2/video/${vimeoId}.json`,
    data => {
      $('[data-vimeo-image]')
        .attr('src', data[0].thumbnail_large)
        .css('display', 'block');
    });
}

export default class DynamicVideo {
  constructor(section) {
    this.$el = $(section.el);
    this.initializedClass = 'video-initialized';
    this.videoId = section.data.settings.videoId;
    this.videoType = section.data.settings.videoType;

    this.$iframePlaceholder = this.$el.find('[data-external-video-iframe-placeholder]');

    rimg.instance.track(this.$el[0]);

    if (this._inViewport()) {
      this._init();
    } else {
      this.$el.on('rimg:enter', () => this._init());
    }
  }

  _bindEvents() {
    this.events = [
      $('.home-video-play-button', this.$el).on('click.video', event => this.openVideo(event)),
      $('body').on('keyup.video', event => this.closeVideo(event)),
    ];
  }

  _init() {
    if (this.videoType === 'youtube') {
      this.$iframePlaceholder.html(`<iframe src="https://www.youtube.com/embed/${this.videoId}" frameborder="0" loading="lazy" allowfullscreen></iframe>`);
    } else if (this.videoType === 'vimeo') {
      this.$iframePlaceholder.html(`<iframe src="https://player.vimeo.com/video/${this.videoId}?color=ffffff&title=0&byline=0&portrait=0" frameborder="0" loading="lazy" allowfullscreen></iframe>`);
    }

    this._bindEvents();
    this.timeouts = [];
    this._validate();
  }

  _inViewport() {
    const rect = this.$el[0].getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.video'));
  }

  update($el) {
    this.$el = $el;
    this._validate();
  }

  _validate() {
    if ($('.home-video', this.$el).length) {
      this.videoWrapper = $('.home-video-embed-wrapper', this.$el);
      this.video = $('.home-video-embed', this.$el);
      this.detachedVideo = null;
    }

    if ($('[data-vimeo-image]', this.$el).length) {
      loadVimeoThumbnail(this.videoId);
    }
  }

  openVideo() {
    this.videoWrapper.addClass('opening');

    if (this.detachedVideo) {
      this.video.width('');
      this.detachedVideo.appendTo(this.video);
    } else {
      // scope fitVids to this shopify section using the section id, because fitVids will only
      // accept a css selector, not an element.
      fitVids(`#${this.$el.attr('id')}`);
    }

    this.verticallyCenterVideo();

    this.events.push(
      $(window).on('resize.video', () => this.verticallyCenterVideo()),
      this.videoWrapper.on('click.video', () => this.closeVideo()),
    );

    this.timeouts.push(setTimeout(() => this.videoWrapper.addClass('open'),
      20));
  }

  centerVideoText() {
    const videoContent = $('.home-video-content', this.$el);

    const contentWidth = videoContent.outerWidth();
    const contentHeight = videoContent.outerHeight();

    videoContent.css({
      marginTop: -(contentHeight / 2),
      marginLeft: -(contentWidth / 2),
    });
  }

  verticallyCenterVideo() {
    // Reset everything so the calculations are always fresh
    this.video.css({
      marginTop: 0,
      width: '100%',
    });

    const video = this.video.find('.fluid-width-video-wrapper');
    const videoHeight = video.outerHeight();
    const videoRatio = video.width() / videoHeight;
    const windowHeight = window.innerHeight || $(window).height();
    const availableHeight = windowHeight - 60; // for padding

    if (videoHeight > availableHeight) {
      this.video.removeClass('centered').css({
        marginTop: 0,
        width: availableHeight * videoRatio,
      });
    } else {
      this.video.addClass('centered').css({
        marginTop: -(videoHeight / 2),
        width: '100%',
      });
    }
  }

  closeVideo(e) {
    if (!$('.home-video', this.$el).length) { return; }

    if (e && this.videoWrapper.hasClass('open')) {
      if (e.which !== 27) { return; }
    }

    $(window).off('resize.video');
    this.videoWrapper.off('click.video');
    this.videoWrapper.removeClass('open');

    this.events.push(this.videoWrapper.one('transitionend.video', () => {
      if (this.videoWrapper.hasClass('opening')) {
        this.videoWrapper.removeClass('opening');
        this.detachedVideo = this.video.find('.fluid-width-video-wrapper').detach();
      }
    }));
  }

  onSectionUnload() {
    this._unbindEvents();
    this.timeouts.forEach(timeout => clearTimeout(timeout));
  }
}
